
/**
 * Returns [ width, height ] of image in px
 * @returns {Promise<[number, number]>}
 */
export const readImageDimensions = async(src: string): Promise<[number, number]> => {
    return Promise.race([
        new Promise((_, reject) => setTimeout(reject, 1000 * 15)),
        new Promise((resolve, reject) => {
            let image = new Image();

            image.onerror = reject;
            image.onload = () => {
                resolve([image.width, image.height]);
                image = null;
            };

            image.src = src;
        }),
    ]) as any;
};
